import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets.app/images/no-results.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("section", { class: "filter-box filter-box--highlights" }, null, -1)
const _hoisted_2 = { class: "no-results-found" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "no-results-found__content" }
const _hoisted_5 = { class: "no-results-found__content-c" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "no-results-found__img",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "no-results-found__title" }, "Page not found...", -1)
const _hoisted_8 = { class: "no-results-found__text" }

import Layout from '@/app/components/Layout.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Page404',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(Layout, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("p", _hoisted_8, [
                _createTextVNode(" Page not found, but you can find some books and pages "),
                _createVNode(_component_router_link, {
                  to: { name: 'books' },
                  class: "no-results-found__link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("here")
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_router_link, { to: { name: 'books' } }, {
                default: _withCtx(() => [
                  _createTextVNode("-- Open books ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})